import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ObservableMedia } from '@angular/flex-layout';
import { FormBuilder } from '@angular/forms';
import { values } from 'lodash';
import { DialogService } from 'src/app/services';
import * as _ from 'lodash';
import { MAT_DIALOG_DATA } from '@angular/material';
// import { BillingInvoiceReportService } from '../billing-invoice-report.service';

@Component({
  selector: 'esc-incidental-fee-breakdown-popup',
  templateUrl: './incidental-fee-breakdown-popup.component.html',
  styleUrls: ['./incidental-fee-breakdown-popup.component.scss']
})
export class IncidentalFeeBreakdownPopupComponent implements OnInit {

  constructor(
    // public billInvRepSvc: BillingInvoiceReportService,
    private dialogService: DialogService,
    public media: ObservableMedia,
    private fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  headerColumns: string[] = [
    'header_label',
    'header_value'
  ];
  
  displayedColumns: string[] = [
    'label',
    'value'
  ];

  readonly headerRows = [
    {
      header_label: "HBL : ",
      border: false
    },
    {
      header_label: "CBM : ",
      divider: true,
      border: true
    },
  ]

  readonly tableRows = [
    {
      label: "Return of Empty Container",
      value: Number(0).toFixed(2)
    },
    {
      label: "Control Fees",
      value: Number(0).toFixed(2)
    },
    {
      label: "Parking Fees",
      value: Number(0).toFixed(2)
    },
    {
      label: "Detention, Demurrage or Storage Charges",
      value: Number(0).toFixed(2)
    },
    {
      label: "E-TRACC System Charge",
      value: Number(0).toFixed(2)
    },
    {
      label: "X-ray Fees",
      value: Number(0).toFixed(2)
    },
    {
      label: "TABS Charge",
      value: Number(0).toFixed(2)
    },
    {
      label: "Container Maintenance Fee",
      value: Number(0).toFixed(2)
    },
    {
      label: "Warehouse Inventory System Fees",
      value: Number(0).toFixed(2)
    },
  ]
  
  public headerData = []
  public listData = []

  public error = {
    init: false
  };
  public loading = {
    init: false,
    more: false,
    export: false,
    import: false
  };

  ngOnInit() {
    this.mapValueToTableRow()
  }

  mapValueToTableRow() {

    this.headerData = _.cloneDeep(this.headerRows)
    this.listData = _.cloneDeep(this.tableRows)

    if(this.data) {
      this.headerData[0].header_value = this.data.hblNumber
      this.headerData[1].header_value = this.data.cbm

      if(this.data.incidentalFee) {
        this.listData[0].value = this.data.incidentalFee.returnEmptyContainer 
        ? Number(this.data.incidentalFee.returnEmptyContainer).toFixed(2) 
        : Number(0).toFixed(2)

        this.listData[1].value = this.data.incidentalFee.controlFee
          ? Number(this.data.incidentalFee.controlFee).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[2].value = this.data.incidentalFee.parkingFee
          ? Number(this.data.incidentalFee.parkingFee).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[3].value = this.data.incidentalFee.ddsCharges
          ? Number(this.data.incidentalFee.ddsCharges).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[4].value = this.data.incidentalFee.eTraccSystemCharges
          ? Number(this.data.incidentalFee.eTraccSystemCharges).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[5].value = this.data.incidentalFee.xRayFees
          ? Number(this.data.incidentalFee.xRayFees).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[6].value = this.data.incidentalFee.tabsCharges
          ? Number(this.data.incidentalFee.tabsCharges).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[7].value = this.data.incidentalFee.containerMaintenanceFee
          ? Number(this.data.incidentalFee.containerMaintenanceFee).toFixed(2) 
          : Number(0).toFixed(2)

        this.listData[8].value = this.data.incidentalFee.imsFee
          ? Number(this.data.incidentalFee.imsFee).toFixed(2) 
          : Number(0).toFixed(2)
      }
    }
  }

}
